import { motion } from "framer-motion";
import { ChevronRight } from "lucide-react";
import Navigation from "../../components/Navigation";
import PageHero from "../../components/PageHero";

// Partner Agencies Page
const PartnerAgenciesPage = () => {
  const partners = [
    { 
      name: "The Pettaway Pursuit Foundation", 
      url: "https://pettawaypursuitfoundation.org/",
      logo: "https://customer-assets.emergentagent.com/job_market-for-good/artifacts/h0v1vsyo_Pettaway.png"
    },
    { 
      name: "The Lotus Center for Wellness and Healing", 
      url: "https://www.thelotuscenterwh.com/",
      logo: "https://customer-assets.emergentagent.com/job_market-for-good/artifacts/k28p99n2_Lotus%20Center.png"
    },
    { 
      name: "The Black Brain Campaign", 
      url: "https://joinbbc.org/",
      logo: "https://customer-assets.emergentagent.com/job_market-for-good/artifacts/bybwi9o1_Black%20Brain%20Campaign.png"
    },
    { 
      name: "Holistic Care 4 You", 
      url: "https://www.psychologytoday.com/us/psychiatrists/holisticare4you-upper-darby-pa/1462485",
      logo: "https://customer-assets.emergentagent.com/job_4bb091c1-e4be-474e-9067-19b51e555ba6/artifacts/ha4tca21_Holisticare%204%20You.png"
    },
    { 
      name: "The Movement of Immigrant Leaders in Pennsylvania (MILPA)", 
      url: "https://www.milpafamilia.org/",
      logo: "https://customer-assets.emergentagent.com/job_market-for-good/artifacts/1nc3hupm_MILPA.png"
    },
    { 
      name: "Centro de Apoyo Comunitario", 
      url: "https://www.centroapoyo.org/",
      logo: "https://customer-assets.emergentagent.com/job_market-for-good/artifacts/tyft5pbx_Centro%20de%20Apoyo.jpg"
    }
  ];

  const regularPartners = [
    { name: "Maternity Care Coalition", url: "https://maternitycarecoalition.org/", logo: "https://customer-assets.emergentagent.com/job_25fea3a8-d44f-4611-af87-de4e9c9c0796/artifacts/ddglxeya_Maternity%20Care%20Coaltion.png" },
    { name: "Delaware County Health Department", url: "https://delcopa.gov/health", logo: "https://customer-assets.emergentagent.com/job_25fea3a8-d44f-4611-af87-de4e9c9c0796/artifacts/9fr5dgsa_DCHD.png" },
    { name: "Saint Joseph's University's Health Promoter Program", url: "https://icbhealthpromoter.org/about/", logo: "https://customer-assets.emergentagent.com/job_25fea3a8-d44f-4611-af87-de4e9c9c0796/artifacts/gzupuku9_SJU%20Health%20Promoters.png" },
    { name: "Jefferson Health Mobile Cancer Screening Unit", url: "https://www.jeffersonhealth.org/your-health/classes-and-events/mobile-cancer-screenings", logo: "https://customer-assets.emergentagent.com/job_25fea3a8-d44f-4611-af87-de4e9c9c0796/artifacts/q9gjr5im_Jefferson%20Health.jpg" },
    { name: "Alpha Kappa Alpha Sorority, Alpha Delta Mu Omega Chapter", url: "https://akawebnet.aka1908.net/eweb/dynamicpage.aspx?webcode=cl_public", logo: "https://customer-assets.emergentagent.com/job_25fea3a8-d44f-4611-af87-de4e9c9c0796/artifacts/bnvs3l6n_Alpha%20Kappa%20Alpha.png" },
    { name: "The office of State Senator Tim Kearney", url: "https://www.senatorkearney.com/", logo: "https://customer-assets.emergentagent.com/job_25fea3a8-d44f-4611-af87-de4e9c9c0796/artifacts/skjvlunq_Tim%20Kearney.png" },
    { name: "Put People First! PA", url: "https://putpeoplefirstpa.org/", logo: "https://customer-assets.emergentagent.com/job_25fea3a8-d44f-4611-af87-de4e9c9c0796/artifacts/i99b69se_Put%20People%20First.jpg" },
    { name: "Delco Book Bank", url: "https://delcobookbank.org/", logo: "https://customer-assets.emergentagent.com/job_25fea3a8-d44f-4611-af87-de4e9c9c0796/artifacts/kcfd96ox_Delco%20Book%20Bank.png" },
  ];

  return (
    <div data-testid="partner-agencies-page" className="min-h-screen bg-[#FAFAFA]">
      <Navigation />
      
      <PageHero 
        image="https://customer-assets.emergentagent.com/job_7b46b431-509a-4162-84d5-ce52c765da4c/artifacts/j3jmcdiu_Vaccine%20clinic%20December%202024.jpg"
        alt="Murphy's Giving Market Partner Agencies"
        objectPosition="center 35%"
      />

      {/* Partner Agencies Content */}
      <section className="py-12 md:py-20 px-4 md:px-8 lg:px-12">
        <div className="max-w-4xl mx-auto">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            <h1 
              data-testid="partner-agencies-title"
              className="text-3xl md:text-4xl lg:text-5xl font-bold text-[#1A1A1A] mb-4"
              style={{ fontFamily: "'Playfair Display', serif" }}
            >
              Partner Agencies
            </h1>
            
            <p 
              data-testid="partner-agencies-subtitle"
              className="text-[#666666] text-base md:text-lg mb-12"
            >
              The following organizations have offices at Murphy's Giving Market:
            </p>
            
            <div className="space-y-4">
              {partners.map((partner, index) => (
                <motion.div
                  key={partner.name}
                  initial={{ opacity: 0, x: -20 }}
                  animate={{ opacity: 1, x: 0 }}
                  transition={{ duration: 0.5, delay: index * 0.1 }}
                  className="bg-white rounded-xl shadow-sm border border-gray-100 p-6"
                >
                  <a 
                    href={partner.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-center gap-4 group"
                  >
                    <img 
                      src={partner.logo} 
                      alt={`${partner.name} logo`}
                      className="h-16 w-auto max-w-[140px] object-contain flex-shrink-0"
                    />
                    <span 
                      className="font-semibold text-lg text-[#1A1A1A] group-hover:text-[#666666] transition-colors"
                      style={{ fontFamily: "'Playfair Display', serif" }}
                    >
                      {partner.name}
                    </span>
                    <ChevronRight size={18} className="text-[#1A1A1A] group-hover:text-[#666666] transition-colors ml-auto flex-shrink-0" />
                  </a>
                </motion.div>
              ))}
            </div>

            {/* Regular Partners Section */}
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.3 }}
              className="mt-12"
            >
              <p className="text-[#666666] text-base md:text-lg mb-6">
                The following organizations are also regularly at Murphy's Giving Market:
              </p>
              
              <div className="space-y-3">
                {regularPartners.map((org, index) => (
                  <motion.div
                    key={org.name}
                    initial={{ opacity: 0, x: -20 }}
                    animate={{ opacity: 1, x: 0 }}
                    transition={{ duration: 0.5, delay: 0.4 + index * 0.05 }}
                    className="bg-white rounded-xl shadow-sm border border-gray-100 p-5"
                  >
                    <a 
                      href={org.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="flex items-center gap-4 group"
                    >
                      {org.logo && (
                        <img 
                          src={org.logo} 
                          alt={`${org.name} logo`}
                          className="h-12 w-auto max-w-[80px] object-contain flex-shrink-0"
                        />
                      )}
                      <span 
                        className="font-semibold text-lg text-[#1A1A1A] group-hover:text-[#666666] transition-colors"
                        style={{ fontFamily: "'Playfair Display', serif" }}
                      >
                        {org.name}
                      </span>
                      <ChevronRight size={18} className="text-[#1A1A1A] group-hover:text-[#666666] transition-colors ml-auto flex-shrink-0" />
                    </a>
                  </motion.div>
                ))}
              </div>
            </motion.div>
          </motion.div>
        </div>
      </section>
    </div>
  );
};

export default PartnerAgenciesPage;
